import * as Icons from "lucide-react";

export function getIcon(name, props = {}) {
  const Cmp = Icons[name] || Icons.Sparkles;
  return <Cmp {...props} />;
}
